import { createBrowserRouter } from 'react-router';

import { ComponentsPage } from '@/features/components/ComponentsPage';
import { ConfigEditPage } from '@/features/config/ConfigEditPage';
import { ConfigHistoryPage } from '@/features/config/ConfigHistoryPage';
import { ConfigListPage } from '@/features/config/ConfigListPage';
import { ScopeTemplatesPage } from '@/features/config/ScopeTemplatesPage';
import { IncidentsPage } from '@/features/incidents/IncidentsPage';
import { OverviewPage } from '@/features/overview/OverviewPage';
import { ProposalPage } from '@/features/proposals/ProposalPage';
import { QueuePage } from '@/features/queue/QueuePage';
import { RunHistoryPage } from '@/features/runs/RunHistoryPage';

import { NotFoundPage, RouteErrorPage } from './errors';
import { ScopeLayout } from './ScopeLayout';
import { Shell } from './Shell';

export function createRouter() {
  return createBrowserRouter([
    {
      path: '/',
      element: <Shell />,
      errorElement: <RouteErrorPage />,
      children: [
        { index: true, element: <OverviewPage /> },
        {
          path: 'scopes/:scope',
          element: <ScopeLayout />,
          children: [
            { index: true, element: <ComponentsPage /> },
            { path: 'queue', element: <QueuePage /> },
            { path: 'incidents', element: <IncidentsPage /> },
            { path: 'components/:capabilityId/runs', element: <RunHistoryPage /> },
            { path: 'config', element: <ConfigListPage /> },
            { path: 'config/_scope', element: <ScopeTemplatesPage /> },
            { path: 'config/:capabilityId', element: <ConfigEditPage /> },
            { path: 'config/:capabilityId/history', element: <ConfigHistoryPage /> },
          ],
        },
        { path: 'proposals/:proposalId', element: <ProposalPage /> },
        { path: '*', element: <NotFoundPage /> },
      ],
    },
  ]);
}
